module.exports = __webpack_public_path__ + "static/media/gdpr-icon.222ccac6.svg";